'use client';

import React from 'react';

interface SubmitButtonProps {
  isSubmitting: boolean;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({ isSubmitting }) => {
  return (
    <button
      type="submit"
      disabled={isSubmitting}
      className="w-full text-white font-bold py-4 px-6 rounded-lg transition-all duration-300 text-lg shadow-lg transform hover:-translate-y-1 border disabled:opacity-50 disabled:cursor-not-allowed"
      style={{ 
        background: isSubmitting ? '#6b7280' : 'var(--gradient-primary)',
        borderColor: 'var(--color-rr-green)',
        boxShadow: '0 10px 25px rgba(29, 131, 64, 0.25)'
      }}
    >
      {isSubmitting ? 'Sending Request...' : 'Get Free Quote'}
    </button>
  );
};

export default SubmitButton;